const REFERENCE_ASSETS = require('../reference-assets.js');
const coins = require('../coins');

module.exports = [
  {
    dataIndex: 0,
    id: 'aave',
    name: 'aave',
    lpTokenInfo: {
        name: 'aaveCurve',
        symbol: 'a3Crv',
    },
    coingeckoInfo: {
        id: 'aave',
        symbol: 'AAVE',
    },
    assets: 'DAI.e+USDC.e+USDT.e',
    coins: [
        coins.adai,
        coins.ausdc,
        coins.ausdt,
    ],
    underlyingCoins: [
        coins.daie,
        coins.usdce,
        coins.usdte,
    ],
    isLendingPool: true,
    isModernLendingPool: true,
    addresses: {
        swap: '0x7f90122BF0700F9E7e1F688fe926940E8839F353',
        lpToken: '0x1337BedC9D22ecbe766dF105c9623922A27963EC',
        gauge: '0x5B5CFE992AdAC0C9D48E05854B2d91C73a003858',
    },
    gaugeVersion: 3, // No CRV rewards
    additionalRewards: [{
        key: 'CRV3POOL',
        name: 'CRV',
        amountDataKey: 'crvRewards',
        rewardTokenAddress: '0x47536F17F4fF30e64A96a7555826b8f9e66ec468',
        rewardTokenDecimals: 18,
        rewardContract: '0xB504b6EB06760019801a91B451d3f7BD9f027fC9',
        rewardTokenCoingeckoId: 'curve-dao-token',
    }],
    oldAdditionalRewards: [{
        key: 'WAVAX3POOL',
        name: 'WAVAX',
        rewardTokenCoingeckoId: 'avalanche-2',
        rewardTokenDecimals: 18,
        rewardTokenAddress: '0xB31f66AA3C1e785363F0875A1B74E27b85FD66c7',
        rewardContract: '0xB504b6EB06760019801a91B451d3f7BD9f027fC9'
    }],
    hasNoCRVRewards: true,
  },
  {
    dataIndex: 1,
    id: 'ren',
    name: 'ren',
    lpTokenInfo: {
        name: 'renCurve',
        symbol: 'renCrv',
    },
    coingeckoInfo: {
        id: 'renbtc',
        symbol: 'RENBTC',
        referenceAssetId: 'bitcoin',
    },
    assets: 'aaWBTC+renBTC',
    coins: [
        coins.aawbtc,
        coins.renbtc
    ],
    underlyingCoins: [
        coins.wbtc,
        coins.renbtc
    ],
    isLendingPool: true,
    referenceAsset: REFERENCE_ASSETS.BTC,
    isModernLendingPool: true,
    addresses: {
        swap: '0x16a7DA911A4DD1d83F3fF066fE28F3C792C50d90',
        lpToken: '0xC2b1DF84112619D190193E48148000e3990Bf627',
        gauge: '0x0f9cb53Ebe405d49A0bbdBD291A65Ff571bC83e1',
    },
    gaugeVersion: 3, // No CRV rewards
    additionalRewards: [
    {
        key: 'CRVREN',
        name: 'CRV',
        amountDataKey: 'crvRewards',
        rewardTokenAddress: '0x47536F17F4fF30e64A96a7555826b8f9e66ec468',
        rewardTokenDecimals: 18,
        rewardContract: '0x75D05190f35567e79012c2F0a02330D3Ed8a1F74',
        rewardTokenCoingeckoId: 'curve-dao-token',
    }],
    hasNoCRVRewards: true,

  },
  {
  dataIndex: 2,
  id: 'atricrypto',
  name: 'atricrypto',
  lpTokenInfo: {
      name: '3CrvCrypto',
      symbol: '3CrvCrypto',
  },
  assets: 'adai+ausdc+ausdt+aeth+abtc',
  coins: [
      coins.daie,
      coins.usdce,
      coins.usdte,
      coins.wbtc,
      coins.weth,
  ],
  addresses: {
      swap: '0xB755B949C126C04e0348DD881a5cF55d424742B2',
      lpToken: '0x1daB6560494B04473A0BE3E7D83CF3Fdf3a51828',
      deposit: '0x58e57cA18B7A47112b877E31929798Cd3D703b0f',
      gauge: '0x445FE580eF8d70FF569aB36e80c647af338db351',
  },
  cryptoPool: true,
  referenceAsset: REFERENCE_ASSETS.CRYPTO,
  isFakePlainPool: true,
  gaugeVersion: 3, // No CRV rewards
  additionalRewards: [{
      key: 'CRVATRICRYPTO',
      name: 'CRV',
      amountDataKey: 'crvRewards',
      rewardTokenAddress: '0x47536F17F4fF30e64A96a7555826b8f9e66ec468',
      rewardTokenDecimals: 18,
      rewardContract: '0xa05E565cA0a103FcD999c7A7b8de7Bd15D5f6505',
      rewardTokenCoingeckoId: 'curve-dao-token',
  }],
  oldAdditionalRewards: [{
      key: 'WAVAXATRICRYPTO',
      name: 'WAVAX',
      amountDataKey: 'wavaxRewards',
      rewardTokenCoingeckoId: 'avalanche-2',
      rewardTokenDecimals: 18,
      rewardTokenAddress: '0xB31f66AA3C1e785363F0875A1B74E27b85FD66c7',
      rewardContract: '0xa05E565cA0a103FcD999c7A7b8de7Bd15D5f6505'
  }],
  hasNoCRVRewards: true,

}, {
  dataIndex: 3,
  id: 'aaveV3',
  name: 'aaveV3',
  lpTokenInfo: {
      name: 'aaveV3Curve',
      symbol: 'a3Crv',
  },
  coingeckoInfo: {
      id: 'aave',
      symbol: 'AAVE',
  },
  assets: 'DAI.e+USDC+USDT',
  coins: [
      coins.adaiv3,
      coins.ausdcv3,
      coins.ausdtv3,
  ],
  underlyingCoins: [
      coins.daie,
      coins.usdc,
      coins.usdt,
  ],
  isLendingPool: true,
  isModernLendingPool: true,
  addresses: {
      swap: '0xD2AcAe14ae2ee0f6557aC6C6D0e407a92C36214b',
      lpToken: '0x5bE26703a658c332CE612eAe3A497059dA98394a',
      gauge: '0x55f9Ba282c39793DB29C68F8f113fC97D23a6445',
  },
  gaugeVersion: 2,
  hasNoGauge: false,
  hasNoCRVRewards: false,
  isMainPoolWithFactoGauge: true,
  routeOverride: 'aave-v3',
}
];
